module.exports = __webpack_public_path__ + "static/img/SearchDetailCredit2.30d355d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailCredit2.png
// module id = 713
// module chunks = 0